import { AccountSwitcherOptionGroup } from "./AccountSwitcherOptionGroup";
import { type WorkplaceDetails } from "./types";
import { type AccountSwitcherUser } from "./useAccountSwitcherHook";

interface AccountSwitcherMenuWorkplaceProps {
  workplaceDetails: WorkplaceDetails;
  handleChange: (user: AccountSwitcherUser) => void;
}

export function AccountSwitcherMenuWorkplace(props: AccountSwitcherMenuWorkplaceProps) {
  const { handleChange, workplaceDetails } = props;

  return <AccountSwitcherOptionGroup userDetails={workplaceDetails} handleChange={handleChange} />;
}
